import { render, staticRenderFns } from "./ImportPropertyWizard.vue?vue&type=template&id=04c324f0&scoped=true&"
import script from "./ImportPropertyWizard.vue?vue&type=script&lang=js&"
export * from "./ImportPropertyWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c324f0",
  null
  
)

export default component.exports